import { render, staticRenderFns } from "./copyCommissionsModal.vue?vue&type=template&id=3c85d22e&scoped=true&"
import script from "./copyCommissionsModal.vue?vue&type=script&lang=js&"
export * from "./copyCommissionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c85d22e",
  null
  
)

export default component.exports